import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ContactPaymentDetailsPage.InfoPanel.FinancialDetails', {
    title: 'Financial details',
    bankAccountName: 'Bank account name',
    bankAccountNumber: 'Bank account number',
    reference: 'Reference',
    currency: 'Currency',
    sortCode: 'Sort code',
});
